import Vue from 'vue'
import Router from 'vue-router'
import Cookies from '../http/cookie'
import { userInfo } from '../utils/config'
// import { resolve } from 'bluebird'
// import { resolve } from 'dns'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/protocol', // 用户隐私协议
      name: 'protocol',
      component: resolve => require(['@/pages/protocol/protocol.vue'], resolve)
    },
    {
      path: '/intentionList', // 景区意向客户填写表
      name: 'intentionList',
      component: resolve => require(['@/pages/intentionList/intentionList'], resolve)
    },
    {
      path: '/smgIndex', // 扫码购--首页
      name: 'smgIndex',
      component: resolve => require(['@/pages/SMG/index'], resolve)
    },
    {
      path: '/smgPayment', // 扫码购--支付页面
      name: 'smgPayment',
      meta: {
        title: '门票预订'
      },
      component: resolve => require(['@/pages/SMG/pay/index'], resolve)
      // component: resolve => require(['@/pages/SMG/payment'], resolve)
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/groundScenic', // 景区介绍
      name: 'GroundScenic',
      // component: resolve => require(['@/pages/groundScenic/index'], resolve),
      component: resolve => require(['@/pages/groundScenic/groundScenic'], resolve),
      meta: {
        // keepAlive: true,
        title: '门票'
      }
    },
    {
      path: '/opinion', // 用户评价
      name: 'opinion',
      component: resolve => require(['@/pages/groundScenic/opinion'], resolve),
      meta: {
        title: '用户评价'
      }
    },
    {
      path: '/TicketReservation/', // 门票预定
      name: 'TicketReservation',
      component: resolve => require(['@/pages/TicketReservation/index'], resolve),
      // component: resolve => require(['@/pages/TicketReservation/TicketReservation'], resolve),
      meta: {
        title: '门票预订'
      }
    },
    {
      path: '/TicketsNotPaid/', // 订单未支付
      name: 'TicketsNotPaid',
      component: resolve => require(['@/pages/TicketsNotPaid/TicketsNotPaid'], resolve),
      meta: {
        title: '门票预订'
      }
    },
    {
      path: '/orderDetails', // 订单详情
      name: 'orderDetails',
      component: resolve => require(['@/pages/orderDetails/index'], resolve),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/refundDetails', // 订单详情--退订详情
      name: 'refundDetails',
      component: resolve => require(['@/pages/orderDetails/refundDetail'], resolve),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/refundSuccess', // 订单详情--退订成功
      name: 'refundSuccess',
      component: resolve => require(['@/pages/orderDetails/refundSuccess'], resolve),
      meta: {
        title: '订单'
      }
    },
    {
      path: '/SelfMachine', // 自助机退票--列表
      name: 'SelfMachine',
      component: resolve => require(['@/pages/orderSelfMachine/index'], resolve),
      meta: {
        title: '自助机退票'
      }
    },
    {
      path: '/signinSelfMachine', // 登录--自助机登录页面
      name: 'signinSelfMachine',
      component: resolve => require(['@/pages/login/signinSelfMachine'], resolve),
      meta: {
        title: '用户登录'
      }
    },
    {
      path: '/redirect', // 登录--重定向
      name: 'redirect',
      component: resolve => require(['@/pages/login/componnets/redirect'], resolve),
      meta: {
        title: ''
      }
    },
    {
      path: '/signin', // 登录
      name: 'signin',
      component: resolve => require(['@/pages/login/signIn'], resolve),
      meta: {
        title: '用户登录'
      }
    },
    {
      path: '/wxsignin', // 登录
      name: 'wxsignin',
      component: resolve => require(['@/pages/login/wxsignIn'], resolve),
      meta: {
        title: '用户注册'
      }
    },
    {
      path: '/real-names', // 实名
      name: 'real-names',
      component: resolve => require(['@/pages/login/real-names'], resolve),
      meta: {
        title: '领取旅游卡'
      }
    },
    {
      path: '/realsuccess', // 实名成功
      name: 'realsuccess',
      component: resolve => require(['@/pages/login/realsuccess'], resolve),
      meta: {
        title: '领取旅游卡'
      }
    },
    {
      path: '/realfail', // 实名失败
      name: 'realfail',
      component: resolve => require(['@/pages/login/realfail'], resolve),
      meta: {
        title: '领取旅游卡'
      }
    },
    {
      path: '/RefundCard', // 退卡
      name: 'RefundCard',
      component: resolve => require(['@/pages/login/RefundCard'], resolve),
      meta: {
        title: '旅游卡申退'
      }
    },
    {
      path: '/RefundCardall', // 全额退卡
      name: 'RefundCardall',
      component: resolve => require(['@/pages/login/RefundCardall'], resolve),
      meta: {
        title: '旅游卡申退'
      }
    },
    {
      path: '/cancellation', // 注销
      name: 'cancellation',
      component: resolve => require(['@/pages/login/cancellation'], resolve),
      meta: {
        title: '旅游卡申退'
      }
    },
    {
      path: '/tkjd', // 退款进度
      name: 'tkjd',
      component: resolve => require(['@/pages/login/tkjd'], resolve),
      meta: {
        title: '旅游卡申退进度'
      }
    },
    {
      path: '/newsignin', // 登录
      name: 'newsignin',
      component: resolve => require(['@/pages/login/newsignIn'], resolve),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/register', // 注册
      name: 'register',
      component: resolve => require(['@/pages/login/register'], resolve),
      meta: {
        title: '用户注册'
      }
    },
    {
      path: '/forgetPwd', // 忘记密码
      name: 'forgetPwd',
      component: resolve => require(['@/pages/login/forgetPwd'], resolve),
      meta: {
        title: '忘记密码'
      }
    },
    // {
    //   path: '/resetPwd', // 重置密码
    //   name: 'resetPwd',
    //   component: resolve => require(['@/pages/login/pwdReset'], resolve),
    //   meta: {
    //     title: '重置密码'
    //   }
    // },
    {
      path: '/registerSucces', // 注册成功
      name: 'registerSucces',
      component: resolve => require(['@/pages/login/register_succes'], resolve),
      meta: {
        title: '注册成功'
      }
    },
    {
      path: '/certification', // 认证
      name: 'certification',
      meta: {
        title: '实名认证',
        requiresAuth: true
      },
      component: resolve => require(['@/pages/login/certification'], resolve)
    },
    // {
    //   path: '/persoanl', // 个人中心 (废弃)
    //   name: 'persoanl',
    //   component: resolve => require(['@/pages/personal/personal'], resolve)
    // },
    // {
    //   path: '/allorder/:type', // 个人中心--所有订单 (废弃)
    //   name: 'allorder',
    //   meta: {
    //     requiresAuth: true
    //   },
    //   component: resolve => require(['@/pages/personal/allOrder'], resolve)
    // },
    {
      path: '/addUserList', // 联系人列表
      name: 'addUserList',
      meta: {
        requiresAuth: true,
        title: '常用联系人'
      },
      component: resolve => require(['@/pages/personal/addUserList/index'], resolve)
      // component: resolve => require(['@/pages/personal/addUserList'], resolve)
    },
    {
      path: '/addUserInfo', // 添加联系人--新增信息
      name: 'addUserInfo',
      meta: {
        requiresAuth: true,
        title: '新增联系人'
      },
      component: resolve => require(['@/pages/personal/addUserInfo/index'], resolve)
      // component: resolve => require(['@/pages/personal/addUserInfo'], resolve)
    },
    {
      path: '/editUserInfo', // 添加联系人--编辑联系人
      name: 'editUserInfo',
      meta: {
        requiresAuth: true,
        title: '编辑联系人'
      },
      component: resolve => require(['@/pages/personal/editUserInfo/index'], resolve)
      // component: resolve => require(['@/pages/personal/editUserInfo'], resolve)
    },
    {
      path: '/plan', // 攻略列表
      name: 'plan',
      component: resolve => require(['../pages/plan/index.vue'], resolve),
      meta: {
        title: '旅游攻略'
      }
    },
    {
      path: '/infomation', // 资讯列表
      name: 'infomation',
      component: resolve => require(['../pages/infomation/infomation.vue'], resolve),
      meta: {
        title: '资讯'
      }
    },
    {
      path: '/order', // 订单列表
      name: 'order',
      meta: {
        requiresAuth: true,
        title: '订单'
      },
      component: resolve => require(['../pages/order/index.vue'], resolve)
    },
    {
      path: '/my', // 个人中心
      name: 'my',
      meta: {
        requiresAuth: true,
        title: '个人中心'
      },
      component: resolve => require(['../pages/my/my.vue'], resolve)
    },
    {
      path: '/home', // 目的地首页
      meta: {
        title: '易旅通'
      },
      component: resolve => require(['../pages/Home/index.vue'], resolve)
    },
    {
      path: '/travel', // 目的地景区列表(门票)
      name: 'travel',
      meta: {
        title: '门票'
      },
      component: resolve => require(['../pages/travel/index.vue'], resolve)
    },
    {
      path: '/tourGroup/:id', // 目的地景区列表(跟团游)
      meta: {
        title: '跟团游'
      },
      component: resolve => require(['../pages/tourGroup/index.vue'], resolve)
    },
    {
      path: '/tourGroupDetail/:id', // 目的地景区列表(跟团游)
      meta: {
        title: '跟团游详情页'
      },
      component: resolve => require(['../pages/tourGroupDetail/index.vue'], resolve)
    },
    {
      path: '/travelSearch', // 目的地搜索景区列表(门票)
      meta: {
        title: '门票搜索'
      },
      component: resolve => require(['../pages/searchTravel/index.vue'], resolve)
    },
    {
      path: '/travelCard', // 旅游卡
      meta: {
        title: '旅游卡'
      },
      component: resolve => require(['../pages/travelCard/index.vue'], resolve)
    },
    {
      path: '/travelCardDetail', // 旅游卡详情
      meta: {
        title: '旅游卡详情'
      },
      component: resolve => require(['../pages/travelCardDetail/index.vue'], resolve)
    },
    {
      path: '/travelCardUsageIntro', // 旅游卡使用说明
      name: 'travelCardUsageIntro',
      meta: {
        title: '旅游卡使用说明'
      },
      component: resolve => require(['../pages/travelCard/components/usageIntro'], resolve)
    },
    {
      path: '/travelPay', // 旅游卡订单详情
      meta: {
        title: '订单详情'
      },
      component: resolve => require(['../pages/travelPay/index.vue'], resolve)
    },
    {
      path: '/renewCardPay', // 旅游卡续费
      meta: {
        title: '旅游卡续费'
      },
      component: resolve => require(['../pages/renewCardPay/renewCard.vue'], resolve)
    },
    {
      path: '/historyCard', // 历史旅游卡
      meta: {
        title: '绑定历史旅游卡'
      },
      component: resolve => require(['../pages/historyCard/index.vue'], resolve)
    },
    {
      path: '/real-name',   // 实名认证
      meta: {
        title: '实名认证',
        equiresAuth: true
      },
      component: resolve => require(['../pages/login/certification.vue'], resolve)
    },
    {
      path: '/bankList', // 我的银行卡列表
      meta: {
        title: '我的银行卡',
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/myCardLists/index.vue'], resolve)
    },
    {
      path: '/myCard', // 我的银行卡
      meta: {
        title: '我的银行卡',
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/myCard/index.vue'], resolve)
    },
    {
      path: '/addCard', // 添加银行卡
      meta: {
        title: '添加银行卡',
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/addCard/index.vue'], resolve)
    },
    {
      path: '/addCards', // 添加银行卡
      meta: {
        title: '添加银行卡',
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/addCard/index2.vue'], resolve)
    },
    {
      path: '/addCardInfo', // 添加银行卡填写银行卡信息
      meta: {
        title: '填写银行卡信息',
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/addCardInfo/index.vue'], resolve)
    },
    {
      path: '/addCardInfos', // 添加银行卡填写银行卡信息
      meta: {
        title: '填写银行卡信息',
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/addCardInfo/index2.vue'], resolve)
    },
    {
      path: '/confirmOpen', // 确认开通银行卡
      meta: {
        requiresAuth: true
      },
      component: resolve => require(['../pages/Bank/confirmOpen/index.vue'], resolve)
    },
    {
      path: '/openSuccess', // 开通成功
      meta: {
        requiresAuth: true,
        title: '中国银联'
      },
      component: resolve => require(['../pages/Bank/openSuccess/index.vue'], resolve)
    },
    {
      path: '/distributor', // 分销商首页
      meta: {

      },
      component: resolve => require(['../pages/distributor/home/index.vue'], resolve)
    },
    {
      path: '/distributorBuy', // 分销商购票页面
      meta: {

      },
      component: resolve => require(['../pages/distributor/groundScenic/index.vue'], resolve)
      // component: resolve => require(['../pages/distributor/groundScenic/groundScenic.vue'], resolve)
    },
    {
      path: '/distributorPay', // 分销商付账
      meta: {
        title: '门票预订'
      },
      component: resolve => require(['../pages/distributor/pay/index.vue'], resolve)
    },
    {
      path: '/registerRule', // 注册条款
      meta: {
        title: '注册服务条款'
      },
      component: resolve => require(['../pages/login/registerRule.vue'], resolve)
    },
    {
      path: '/privacyPolicy', // 个人信息授权条款
      meta: {
        title: '个人信息授权条款'
      },
      component: resolve => require(['../pages/login/privacyPolicy.vue'], resolve)
    },
    {
      path: '/onBuild', // 经销商付账
      meta: {
        title: '导游导缆系统'
      },
      component: resolve => require(['../pages/onBuild/index.vue'], resolve)
    },
    {
      path: '/changeCity', // 切换城市
      meta: {
        title: '选择城市'
      },
      // component: resolve => require(['../pages/changeCity/index.vue'], resolve)
      component: resolve => require(['../pages/changeCity/changeCity.vue'], resolve)
    },
    {
      path: '/traveTicketDetail', // 旅游卡买票详情
      meta: {
        title: '门票详情'
      },
      component: resolve => require(['../pages/travelCardBuyTicket/ticketDetail/index.vue'], resolve)
    },
    {
      path: '/traveTicketPay', // 旅游卡买票详情
      meta: {
        title: '订单填写'
      },
      component: resolve => require(['../pages/travelCardBuyTicket/ticketPay/index.vue'], resolve)
    },
    {
      path: '/found', // 发现
      meta: {
        title: '发现'
      },
      component: resolve => require(['../pages/found/found.vue'], resolve)
    },
    {
      path: '/activity', // 活动
      meta: {
        title: '活动'
      },
      component: resolve => require(['../pages/activity/activity.vue'], resolve)
    },
    {
      path: '/mine', // 新的我的页面（调试用）
      meta: {
        title: '我的'
      },
      component: resolve => require(['../pages/my/my.vue'], resolve)
    },
    {
      path: '/trafficDetail',
      meta: {
        title: '交通详情'
      },
      component: resolve => require(['../pages/trafficDetail/trafficDetail'], resolve)
    },
    {
      path: '/foodDetail',
      meta: {
        title: '美食详情'
      },
      component: resolve => require(['../pages/foodDetail/foodDetail'], resolve)
    },
    {
      path: '/specialThingDetail',
      meta: {
        title: '特产详情'
      },
      component: resolve => require(['../pages/specialThingDetail/specialThingDetail'], resolve)
    },
    {
      path: '/hotelDetail',
      meta: {
        title: '住宿详情'
      },
      component: resolve => require(['../pages/hotelDetail/hotelDetail'], resolve)
    },
    {
      path: '/feedback',
      meta: {
        title: '意见反馈'
      },
      component: resolve => require(['../pages/my/feedback'], resolve)
    },
    {
      path: '/set',
      meta: {
        title: '设置'
      },
      component: resolve => require(['../pages/my/set'], resolve)
    },
    {
      path: '/resetPwd',
      meta: {
        title: '修改密码'
      },
      component: resolve => require(['../pages/login/resetPwd'], resolve)
    },
    {
      path: '/cardList',
      meta: {
        title: '旅游卡列表'
      },
      component: resolve => require(['../pages/card/cardList'], resolve)
    },
    {
      path: '/myTravelCard',
      meta: {
        title: '我的旅游卡'
      },
      component: resolve => require(['../pages/travelCard/travelCard'], resolve)
    },
    {
      path: '/myCollect',
      meta: {
        title: '我的收藏'
      },
      component: resolve => require(['../pages/myCollect/myCollect'], resolve)
    },
    {
      path: '/intelGuide',
      meta: {
        title: '智能导览'
      },
      component: resolve => require(['../pages/intelGuide/intelGuide'], resolve)
    },
    {
      path: '/articleDetail',
      name: 'articleDetail',
      meta: {
        title: '文章详情'
      },
      component: resolve => require(['../pages/articleDetail/articleDetail'], resolve)
    },
    {
      path: '/myData',
      meta: {
        title: '我的资料'
      },
      component: resolve => require(['../pages/my/myData'], resolve)
    },
    {
      path: '/comment',
      meta: {
        title: '评论'
      },
      component: resolve => require(['../pages/comment/comment'], resolve)
    },
    {
      path: '/cityNews',
      meta: {
        title: '' // 城市预览,人文风情
      },
      component: resolve => require(['../pages/cityNews/cityNews'], resolve)
    },
    {
      path: '/cityList',
      meta: {
        title: '' //
      },
      component: resolve => require(['../pages/Home/components/cityList'], resolve)
    },
    {
      path: '/planSearch',
      meta: {
        title: '搜索攻略',
        keep: true
      },
      component: resolve => require(['../pages/plan/planSearch'], resolve)
    },
    {
      path: '/setHeadImg',
      meta: {
        title: '更换头像'
      },
      component: resolve => require(['../pages/my/setHeadImg'], resolve)
    },
    {
      path: '/setMyData',
      meta: {
        title: '修改信息'
      },
      component: resolve => require(['../pages/my/setMyData'], resolve)
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    let token = Cookies.get('mdd_token')
    let usid = localStorage.getItem(userInfo) ? JSON.parse(localStorage.getItem(userInfo)).userId : ''
    if (token && usid) {
      next()
    } else {
      router.replace({
        path: '/signin',
        query: {
          redirect: router.currentRoute.fullPath
        } // 登录成功后跳入浏览的当前页面
      })
      // next('/signin')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  let v = to.fullPath
  let i = '/home?t='
  let o = '/opinion?t='
  let c = '易旅通'
  if (v.startsWith(i)) {
    c = v.substr(v.indexOf(i) + 8)
    c = decodeURIComponent(c)
    sessionStorage.setItem('indextitle', c)
  }
  else if (v.startsWith(o)) {
    c = v.substr(v.indexOf(o) + 11)
    c = decodeURIComponent(c)
    sessionStorage.setItem('indextitle', c)
  }
  // setTimeout(() => {
  if (sessionStorage.getItem('indextitle')) {
    document.title = sessionStorage.getItem('indextitle')
  }
    // document.title = localStorage.getItem('indextitle') == null ? c : localStorage.getItem('indextitle')
  // }, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js